import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  accessToken: null,
  isSessionInitialized: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken } = action.payload;
      state.user = user;
      state.accessToken = accessToken;
    },

    logout: (state) => {
      state.user = null;
      state.accessToken = null;
    },

    updateAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },

    updateUser: (state, action) => {
      state.user = action.payload;
    },

    setSessionInitialized: (state) => {
      state.isSessionInitialized = true;
    },
  },
});

export const { setCredentials, logout, updateAccessToken, updateUser, setSessionInitialized } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectCurrentUser = (state) => state.auth.user;
export const selectAccessToken = (state) => state.auth.accessToken;
export const selectIsAuthenticated = (state) => !!state.auth.user && !!state.auth.accessToken;
export const selectUserRole = (state) => state.auth.user?.role;
export const selectIsSessionInitialized = (state) => state.auth.isSessionInitialized;